<script setup lang="ts">
import Welcome from '@components/Onboarding/Welcome.vue';
import Sign from '@components/Onboarding/Sign.vue';
import Onfido from '@components/Onboarding/Onfido.vue';

import routes from '@routes';

import { useAuthStore } from '@stores/useAuthStore';

interface Emits {
  (event: 'closeModal'): void;
}

const emit = defineEmits<Emits>();

const { isOnfidoPreliminaryChecked } = toRefs(useAuthStore());

const currentStep = ref(1);

const setCurrentStep = (step: number) => {
  currentStep.value = step;
};

const finishOnboarding = () => {
  isOnfidoPreliminaryChecked.value = true;
  setCurrentStep(4);

  emit('closeModal');
  navigateTo({ name: routes.myRequests });
};
</script>

<template>
  <div class="flex flex-col gap-6">
    <Welcome v-if="currentStep === 1" @update:current-step="setCurrentStep" />
    <Sign v-if="currentStep === 2" @update:current-step="setCurrentStep" @complete:onboarding="finishOnboarding" />
    <Onfido v-if="currentStep === 3" @update:current-step="setCurrentStep" @onfido-completed="finishOnboarding" />
    <div v-if="currentStep === 4" class="grid place-items-center min-h-[400px]">
      <UIMogelijkLoader class="!w-40 h-fit" />
    </div>
  </div>
</template>
